import React from "react";
import {useAppStore} from "../../common/app.store.consumer";
import {AppStore} from "../../stores/app.store";
import TrainingContentList from "./training.content.list";
import TrainingContentSeeMore from "./training.content.see.more";
import TrainingContentFilters from "./training.content.filters";
import {NativeEventInfo} from "devextreme/events";
import dxSelectBox from "devextreme/ui/select_box";
import LoadingOverlay from "../../loading-overlay/loading.overlay";

interface Props {
	appStore?: AppStore;
	questionnaireType: string;
}

@useAppStore()
export default class TrainingContent extends React.Component<Props> {
	private trainingContentStore = this.props.appStore.trainingContentStore;

	async componentDidMount() {
		await this.trainingContentStore.getTrainingContentFilters();
		await this.trainingContentStore.getInitialTrainingContents(this.props.questionnaireType);
	}

	private getMoreTrainingContent = async () => {
		await this.trainingContentStore.getNextPageOfTrainingContents();
	};

	private onClickShowAll = async () => {
		await this.trainingContentStore.toggleShowAll();
	};

	private onTaxonomyFilterChanged = async (e: NativeEventInfo<dxSelectBox>) => {
		const taxonomyId = e ? e.toString() : null;
		await this.trainingContentStore.onChangeTaxonomy(taxonomyId);
	};

	private onMediaTypeFilterChanged = async (e: NativeEventInfo<dxSelectBox>) => {
		const mediaType = e ? e.toString() : null;
		await this.trainingContentStore.onChangeMediaType(mediaType);
	};

	render() {
		return (
			<div className="cih-hide-print">
				<div className="cih-h3">Resources</div>
				<p>Explore the resources below, specifically tailored to help you improve your knowledge and aligned to our professional standards.</p>
				<TrainingContentFilters
					taxonomies={this.trainingContentStore.filters?.taxonomies}
					selectedTaxonomy={this.trainingContentStore.selectedTaxonomy}
					onTaxonomyFilterChanged={this.onTaxonomyFilterChanged}
					mediaTypes={this.trainingContentStore.filters?.mediaTypes}
					selectedMediaType={this.trainingContentStore.selectedMediaType}
					onMediaTypeFilterChanged={this.onMediaTypeFilterChanged}
					showAllValue={this.trainingContentStore.showAll}
					onClickShowAll={this.onClickShowAll}
				/>

				<div id="training-content-loading-area">
					<TrainingContentList trainingContents={this.trainingContentStore.trainings} />
					<div className="cih-flex cih-justify-center cih-my-2">{this.trainingContentStore.hasNext && <TrainingContentSeeMore loadMore={this.getMoreTrainingContent} />}</div>
				</div>

				<LoadingOverlay
					message="My Learning Assets Loading..."
					position={{of: "#training-content-loading-area"}}
					visible={this.trainingContentStore.isTrainingContentsLoading || this.trainingContentStore.isSeeMoreLoading}
				/>
			</div>
		);
	}
}
